import { render, staticRenderFns } from "./logCell.vue?vue&type=template&id=1bbead6a&scoped=true&"
import script from "./logCell.vue?vue&type=script&lang=js&"
export * from "./logCell.vue?vue&type=script&lang=js&"
import style0 from "./logCell.vue?vue&type=style&index=0&id=1bbead6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbead6a",
  null
  
)

export default component.exports